import { useMemo } from "react";
import { checkPermission } from "../../utils/Roles";
import HelpIconButton from "../HelpIconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import DmvQuerySelect from "./DmvQuerySelect";

export const lookup = {
  "SVQ - 28": "10-28 VT and Out of State by Plate or VIN",
  "SNQ - 27 Name/DOB": "10-27 VT and Out of State by Name & DOB",
  "RQ - VIN": "10-28 Out of State by VIN with Make & Year",
  "QVP - Registered 28 by PID": "10-28s Registered to VT PID",
  "QDL - 27 VT PID": "10-27 by PID (VT Only)",
  "DQ - 27 OOS PID": "10-27 Out of State by PID/OLN",
  "QNM - 27 Name/DOB Soundex": "Name Search with optional DOB, plus SOUNDEX",
  "XQ - 28 Canadian": "10-28 in Canada by Plate or VIN",
  "UQ - 27 Canadian": "10-27 in Canada by Name and DOB or OLN",
  "KQ - 27 Driver History":
    "10-27 Driver History by OLN or Name, DOB, and Gender",
  "SQ - 28 Snowmobile": "10-28 Snowmobile by Registration, VIN, or Name/DOB",
  "BQ - 28 Boat":
    "10-28 Boat by Registration, Hull Number, Name/DOB, or Coast Guard number",
};
const _spacing = "10px";

const StyledAccordionSummary = withStyles({
  root: {
    backgroundColor: props =>
      props.nightmode === "true" ? "#616161" : "#fae8ad",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "0",
    },
  },
  expanded: {},
})(AccordionSummary);

const TopHalf = ({
  formState,
  handleChange,
  setFormState,
  expandUserInfo,
  setExpandUserInfo,
  nightMode,
  querySelection,
  setQuerySelection,
  user,
  queryTypes,
}) => {
  const canEditDeviceId = useMemo(() => {
    return checkPermission(
      user?.roleNames,
      "edit_dev_id_sub_ori",
      "ALL",
      null,
      null
    );
  }, [user?.roleNames]);

  function headerName(name) {
    const text = lookup[name] || "";
    const styleObject = {
      color: nightMode ? "white" : "black",
      margin: 0,
      display: "flex",
      alignItems: "center",
    };

    return (
      <h3 style={styleObject}>
        {text} {expandUserInfo ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </h3>
    );
  }

  return (
    <Accordion
      data-testid="query-modal-top-half-accordion"
      square
      expanded={expandUserInfo}
      onChange={() => {
        console.log("Accordion onChange triggered");
        setExpandUserInfo(!expandUserInfo);
      }}
      TransitionProps={{ unmountOnExit: false }}
    >
      <StyledAccordionSummary
        data-testid="query-modal-top-half-accordion-summary"
        nightmode={nightMode?.toString()}
        style={{ margin: 0 }}
        aria-controls="panel1d-content"
        id="panel1d-header"
      >
        <div
          id="header"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "5px",
            paddingRight: "1vw",
            paddingLeft: "1vw",
            width: "100%",
          }}
        >
          {headerName(querySelection?.name)}
          <DmvQuerySelect
            nightMode={nightMode}
            value={querySelection}
            setValue={setQuerySelection}
            options={queryTypes.map(option => ({
              ...option,
              tooltip: lookup[option.name],
            }))}
          />
          <HelpIconButton objectname="mobile_query_modal" />
        </div>
      </StyledAccordionSummary>
      <AccordionDetails type="button" onClick={e => e?.stopPropagation()}>
        <div
          id="top-half"
          style={{
            border: "1px solid black",
            display: "flex",
            flexDirection: "column",
            alignContent: "space-between",
            padding: _spacing,
            margin: _spacing,
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <TextField
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              margin="dense"
              id="sub-ori-id"
              label="Sub-ORI"
              value={formState?.nletsOri || ""}
              onChange={e => handleChange(e, setFormState)}
              name="nletsOri"
              style={{ width: "45%" }}
              disabled={!canEditDeviceId}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <TextField
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              margin="dense"
              id="nletsDevId-id"
              label="Device ID"
              value={formState?.nletsDevId || ""}
              onChange={e => handleChange(e, setFormState)}
              name="nletsDevId"
              style={{ width: "45%" }}
              disabled={!canEditDeviceId}
            />
            <TextField
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              margin="dense"
              id="nletsLogin-id"
              label="User Name"
              value={formState?.nletsLogin || ""}
              onChange={e => handleChange(e, setFormState)}
              name="nletsLogin"
              style={{ width: "45%" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "wrap",
              alignItems: "space-between",
            }}
          >
            <TextField
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              margin="dense"
              id="nletsPassword-id"
              label="Password"
              type="password"
              value={formState?.nletsPassword || ""}
              onChange={e => handleChange(e, setFormState)}
              name="nletsPassword"
              style={{ width: "45%" }}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default TopHalf;
